module.exports = __webpack_public_path__ + "static/media/connect.9a346be5.PNG";